import mergeStyles from './mergeStyles';
import isComponent from './isComponent';
export default {
    mergeStyles,
    isComponent,
};
//# sourceMappingURL=index.js.map